import { useNavigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import backgroundImg from "../../assets/images/vectors/background.png";
import messages from "../../assets/locale/messages";
import coloredLogo from "../../assets/images/logo-colored.png";
import fullLogoColored from "../../assets/images/full-logo-colored.png";
import Footer from "../Layout/Footer";
import NotificationSnackbar from "../NotificationSnackbar";
import { LAYOUT_DIMENSIONS } from "../../utils/Constants";
import { getInitialRoute } from "../../utils/Roles";
import "./AuthLayout.scss";

const AuthLayout = () => {
  const lang = useSelector((state) => state.locale.lang);
  const { shared } = messages[lang];

  const navigate = useNavigate();

  return (
    <div className="auth-layout-container">
      <div className="d-flex main-content">
        <div className="d-flex justify-content-center align-items-center flex-grow-1 position-relative form-section">
          <div className="d-flex flex-column align-items-start component-section h-100">
            <div className="desktop-logo-container py-4 mb-5">
              <div
                className="logo mb-3 pointer"
                onClick={() => navigate(getInitialRoute())}>
                <img src={fullLogoColored} />
              </div>
            </div>
            <div className="layout-card d-flex flex-column align-items-center">
              <div className="mobile-logo-container text-center pt-4 pb-3 px-3">
                <div
                  className="logo mb-3 pointer"
                  onClick={() => navigate(getInitialRoute())}>
                  <img src={coloredLogo} />
                </div>
                <h3 className="title-color fsize-20 fweight-500 welcome-title">
                  {shared.auth.welcomeTitle}
                </h3>
                <p className="grey-white welcome-msg mb-1 px-5">
                  {shared.auth.welcomeMsg}
                </p>
              </div>
              <Outlet />
            </div>
          </div>
        </div>
        <div className="gradient-section p-3">
          <div
            className="gradient-bg border-radius-10"
            style={{
              backgroundImage: `url(${backgroundImg})`
            }}>
            <div className="welcome-text w-80 mx-auto text-center">
              <h3 className="text-white fsize-40 fweight-600 mb-4 welcome-title">
                {shared.auth.welcomeTitle}
              </h3>
              <p className="text-white fsize-20 fweight-500 mb-1">
                {shared.auth.welcomeMsg}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer footerHeight={LAYOUT_DIMENSIONS.footerHeight} />
      <NotificationSnackbar />
    </div>
  );
};

export default AuthLayout;
